import type {
  FilterCategory,
  Filter,
  NormalizedFilters,
  RawFilter,
  RawCategory,
} from "@interfaces/filters";

export function normalizeCategories(data: RawCategory[]): NormalizedFilters {
  const categories: FilterCategory[] = [];
  const filters: Filter[] = [];
  data.forEach((category) => {
    const filterIds: number[] = [];
    if (!category?.categoryId) {
      return;
    }

    category.filterResponse.forEach((filter: RawFilter) => {
      filterIds.push(filter.filterId);

      const filterObj: Filter = {
        id: filter.filterId,
        name: filter.filterName,
        filterOrder: filter.filterOrder,
        filterType: filter.filterType,
        filterMarket: filter.filterMarket,
        filterGroup: filter.filterGroup,
        detachedFilters: filter.detachedFilters,
        expiredFilters: filter.expiredFilters,
        isExpired: filter.isExpired,
        unFieldingFilters: filter.unFieldingFilters,
        filterGroupOrder: filter.filterGroupOrder,
        filterOptions: filter.filterOptions.map((option) => {
          return {
            filterOptionId: option.filterOptionId,
            filterOptionName: option.filterOptionName,
          };
        }),
        categoryId: category.categoryId,
      };

      filters.push(filterObj);
    });

    const categoryObj: FilterCategory = {
      id: category.categoryId,
      name: category.categoryName,
      categoryType: category.categoryType,
      categoryOrder: category.categoryOrder,
      filterIds: filterIds,
    };

    categories.push(categoryObj);
  });

  return { categories, filters };
}
